import { DraggableSyntheticListeners } from '@dnd-kit/core';
import React from 'react';

import { Handle, SwitchListItem } from './Item.style';

type ItemProps = {
    id: string;
    style?: React.CSSProperties;
    listeners?: DraggableSyntheticListeners;
};

const Item = React.forwardRef<HTMLDivElement, React.PropsWithChildren<ItemProps>>(({ id, listeners, children, ...props }, ref) => (
    <SwitchListItem dragging={!listeners} {...props} ref={ref}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Handle {...listeners}>
                <svg viewBox='0 0 20 20'>
                    <path d='M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z'></path>
                </svg>
            </Handle>
            {children}
        </div>
    </SwitchListItem>
));

export default Item;
